import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // <-- Keep App, it handles the routing!
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// 1. Look for the specific WordPress container ID
const rootElement = document.getElementById('anr-builder-root');

// 2. Only render if the container exists (Prevents errors on pages without the shortcode)
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  // Optional: Log a warning for debugging, but don't crash the site
  // console.warn("ANR Builder: 'anr-builder-root' div not found. App not loaded.");
}

reportWebVitals();